import React from "react";

function Footer() {
  return (
    <footer style={{background:"#FFF",color:"#000",padding:"10px",textAlign:"center", boxShadow: "0px -9px 20px 3px rgba(0, 0, 0, 0.04)"}}>
      © {new Date().getFullYear()} Teclonex Restaurant Management
    </footer>
  );
}

export default Footer;